<div class="media">
    <ng-content class="media-object" select="fui-icon"></ng-content>
</div>
<div class="modal">
    <div class="modal-window">
        <div class="modal-window-content">
            {{ title | translate }}
        </div>
    </div>
</div>
